
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Fixovat',
	'find_label': 'Najít',
	'findCancelLabel': 'Storno',
	'dataPaneLabel': 'Data',
	'sourcePaneLabel': 'Vybrané zdroje',
	'sourcePaneContentLabel': 'Vybrat zdroj',
	'emptySourcePaneTitle': 'Vybrat zdroj',
	'emptySourcePaneCaption': 'Klepnutím vyberte zdroj pro přidání dat použitých k sestavení panelu dashboard.',
	'addDataSource': 'Vybrat zdroj',
	'addDataDashboardCoachMarkContents': 'Pomocí myši přetáhněte data z panelu dat na panel dashboard.',
	'addDataStoryCoachMarkContents': 'Pomocí myši přetáhněte data z panelu dat do scénáře.',
	'addDataCoachMarkTitle': 'Přidat data',
	'selectSourcesText': 'Vyberte a přidejte zdroj dat pro vytvoření položky %{app}.',
	'selectSourcesLabel': 'Vybrat zdroj',
	'errorSourcesTitle': 'Nepodařilo se načíst datový strom.',
	'errorLoadingDataSources': 'Při načítání seznamu datových sad došlo k chybě.',
	'errorLoadingDataTree': 'Během načítání stromu došlo k chybě.',
	'dataSetPaneLastUpdated': 'Poslední aktualizace: %{date}',
	'dataSourcePaneDateUnknown': 'Neznámý',
	'moreTitle': 'Další',
	'backLabel': 'Přejít zpět',
	'addDataSourceDialogTitle': 'Vybrat zdroj',
	'addDataSourceDialogButtonLabel': 'Přidat',
	'dlg_use': 'Použití',
	'dlg_RelinkDataSourceTitle': 'Nahradit datovou sadu "%{dataSourceName}" pomocí...',
	'propertiesDialogTitle': 'Vlastnosti',
	'loadingMetadata': 'Načítání metadat',
	'missingDataSetData': 'Data pro tuto datovou sadu nejsou k dispozici. Aktualizujte datovou sadu nebo požádejte administrátora o přístup ke zdroji.',
	'errorLoadingSource': 'Metadata pro "%{sourceName}" nebyla načtena. Požádejte administrátora, aby vám poskytl další podrobností.',
	'errorMessageTitle': 'Chyba',
	'calculation_navigation_in_use': 'Odstranění výpočtů, filtrů nebo navigačních cest zneplatňuje všechny vizualizace, které odkazují na odstraněnou položku. Opravdu chcete toto odstranění provést?',
	'delete_confirm': 'Potvrdit odstranění',
	'previewUnavailable': 'Datová zásuvka a globální filtry nejsou pro tento typ balíku dostupné.',
	'contextualGridTabName': 'Data vizualizace',
	'DATA_TRAY_no_data_text': 'V současné době nemáte žádná data.',
	'contextualGridMenuLabel': 'Nabídka dat vizualizace',
	'contextualGridExport': 'Exportovat',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Prognóza statistických podrobností',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Ukazatele přesnosti',
	'forecastDetailsSmoothingCoefLabel': 'Parametry',
	'forecastDetailsDiagnostics': 'Diagnostika',
	'forecastDetailsForecastLabel': 'Prognóza',
	'forecastDetailsStatusLabel': 'Stav',
	'forecastDetailsAccuracyPercentLabel': 'Přesnost %',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Sezónnost',
	'forecastDetailsSeasonalPeriodLabel': 'Sezónní období',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gama',
	'forecastDetailsPhiLabel': 'Fí',
	'forecastDetailsMissingCount': 'Chybějící počet',
	'forecastDetailsSeriesLengthLabel': 'Délka řady',
	'forecastDetailsIgnoredPeriods': 'Ignorovaná období',
	'forecastDetailsTrendStrength': 'Odolnost trendu',
	'forecastDetailsSeasonalityStrength': 'Odolnost sezónnosti',
	'forecastDetailsTimeDeltaUnit': 'Interval data/času',
	'forecastDetailsNotes': 'Poznámky'
});
